import React, { FC } from 'react'
import cn from 'classnames'
import styles from './Button.module.css'
import { Icon, IconType } from '../Icon'

type Props = {
  type: 'primary' | 'primaryOrange' | 'secondary' | 'secondaryHighlighted'
  buttonSize?: 'medium' | 'large'
  iconLeft?: IconType
}

export const Button: FC<React.HTMLProps<HTMLButtonElement> & Props> = ({
  type = 'light',
  buttonSize = 'medium',
  iconLeft,
  ...otherProps
}) => {
  const { children, className } = otherProps

  return (
    <button
      {...otherProps}
      className={cn([styles[type], className, styles[buttonSize]])}
      type='button'
    >
      {iconLeft && <Icon icon={iconLeft} className={styles.icon} />}
      {children}
    </button>
  )
}
